import React from "react";
import Uploader from "./Uploader";
import NavigateNextRounded from "@mui/icons-material/NavigateNextRounded";

import Lottie from "react-lottie";
import animationData from "assets/json/attachment.json";

import { Grow, Stack, Button, Typography, IconButton } from "@mui/material";
import { CustomList } from "components";

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default function Step02({
  state,
  refetch,
  handleNext,
  handleBack,
  handleState,
}) {
  const { id, title, status, media = [] } = state;

  const license = media.find((x) => x.collection_name === "license");

  const ceoMelliBack = media.find(
    (x) => x.collection_name === "ceo-melli-back"
  );
  const ceoMelliFront = media.find(
    (x) => x.collection_name === "ceo-melli-front"
  );

  return (
    <>
      <Stack p={1} flexGrow={1} rowGap={1} overflow="scroll">
        <Grow in>
          <Stack py={2} rowGap={1}>
            <Lottie options={defaultOptions} height={100} width={120} />
            <Typography align="center" variant="subtitle2" color="textDisabled">
              بارگذاری مدارک
            </Typography>
            <Typography align="center" variant="caption" color="textDisabled">
              لطفاً مدارک کلینیک خود را بارگذاری کنید
            </Typography>
          </Stack>
        </Grow>
        <Stack rowGap={1}>
          <Grow in>
            <Stack rowGap={1}>
              <Uploader
                id={id}
                media={license}
                refetch={refetch}
                model="Doctor"
                collection="license"
                label="پروانه فعالیت"
              />
              <Stack columnGap={1} direction="row">
                <Uploader
                  id={id}
                  media={ceoMelliFront}
                  refetch={refetch}
                  model="Doctor"
                  collection="ceo-melli-front"
                  label="تصویر روی کارت ملی"
                  caption="صاحب پروانه"
                />
                <Uploader
                  id={id}
                  media={ceoMelliBack}
                  refetch={refetch}
                  model="Doctor"
                  collection="ceo-melli-back"
                  label="تصویر پشت کارت ملی"
                  caption="صاحب پروانه"
                />
              </Stack>
            </Stack>
          </Grow>
        </Stack>
      </Stack>
      <Stack
        p={1}
        py={2}
        columnGap={1}
        alignItems="center"
        direction="row-reverse"
      >
        <Button
          fullWidth
          size="large"
          color="primary"
          variant="contained"
          onClick={handleNext}
          disabled={media.length < 3}
        >
          تایید و ادامه
        </Button>
        <IconButton size="medium" color="warning" onClick={handleBack}>
          <NavigateNextRounded />
        </IconButton>
      </Stack>
    </>
  );
}
